function centsToEuros(amount) {
  amount = `${parseInt(amount, 0) / 100}`;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}

export {
  centsToEuros,
};



// WEBPACK FOOTER //
// ./src/utils/numberFormats.js